import template from "./pServiceLines.html";

export function pServiceLinesDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pServiceLinesController,
    controllerAs: 'pServiceLines',
    bindToController: true
  };

  return directive;
}

class pServiceLinesController {
  constructor(Auth, Admin, $scope, $interval, Notes, ConnectionQuality) {
    'ngInject';

    this.Auth = Auth;
    this.Admin = Admin;
    this.$scope = $scope;
    this.$interval = $interval;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;

    this.init();

    this.fields = {
      name: "info"
    };

    this.actions= [
      {
        name: "new",
        functionName: "startAddingNewServiceLine",
        fa: "fa-plus"
      }
    ];

    /*
    * b-dialog-card data
    */

    this.newServiceLineData = {
      name: {
        type: "text"
      }
    };

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;
        this.Admin.getServiceLines().then(
          (success) => {
            this.serviceLines = success.data.sort();
            this.state = 'loaded';
          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({type: "error", error: error});
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  startAddingNewServiceLine() {
    this.newServiceLineValues = null;
    this.newServiceLineProcess = true;
  }

  addNewServiceLine(serviceLine) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.addServiceLine(serviceLine).then(
      () => {
        this.newServiceLineProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }
}
